import React from 'react';
import styled from 'styled-components';
import SearchBar from '../../../components/SearchBar';
import ButtonRadio from '../../TechFormList/components/ButtonRadio';
import colors from '../../../res/styles/Colors';
import dimension from '../../../res/styles/Responsive';
import buttonTheme from '../../../res/styles/theme_button.module.scss';

const TYPE_FILTER_VALUES = [{ name: 'ALL' }, { name: 'PDF' }, { name: 'URL' }];

export default function ResourceFilterBar({ onSearchChange, onTypeFilterChange, isAdmin, onAddClick }) {
    const handleTypeChange = (value) => {
        onTypeFilterChange(value ?? 'All');
    };

    return (
        <FilterBarContainer>
            <SearchBar onSearchChange={onSearchChange} />
            <BottomRow>
                <RadioWrapper>
                    <ButtonRadio
                        values={TYPE_FILTER_VALUES}
                        defaultValueIndex={0}
                        onChangeValue={handleTypeChange}
                        className={buttonTheme.lighterGreen}
                        onActiveStyle={buttonTheme.green}
                    />
                </RadioWrapper>
                {isAdmin && (
                    <AddButton onClick={onAddClick}>Add Resources</AddButton>
                )}
            </BottomRow>
        </FilterBarContainer>
    );
}

const FilterBarContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0;

    @media ${dimension.md} {
        flex-direction: row;
        align-items: center;
        gap: 16px;
        min-height: 9vh;
        padding: 0 2.5%;
        background-color: ${colors.white};
    }
`;

const BottomRow = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 12px 20px;

    @media ${dimension.md} {
        display: contents;
        padding: 0;
    }
`;

const RadioWrapper = styled.div`
    flex: 1;

    @media ${dimension.md} {
        width: 180px;
        flex: none;
        flex-shrink: 0;
    }
`;

const AddButton = styled.button`
    margin-left: auto;
    padding: 6px 20px;
    background-color: ${colors.green};
    color: white;
    border: none;
    border-radius: 26px;
    font-size: 12px;
    cursor: pointer;
    white-space: nowrap;
    flex-shrink: 0;

    &:hover {
        background-color: ${colors.dark_green};
    }
`;
